var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('BoxMainView',{attrs:{"data":{
    image: 'profile/img-mv.jpg',
    japanese: '事業内容',
    title: 'profile/txt-mv.svg',
  },"is-animation":_vm.isAnimate,"to-top":_vm.toTop,"is-fix":_vm.isFix}}),_c('div',{staticClass:"wrapper__inner",class:{'is-animation': _vm.isAnimate, 'is-animation-end': _vm.isAnimateEnd}},[_c('div',{staticClass:"intro"},[_c('div',{staticClass:"intro__inner"},[_c('div',{staticClass:"intro__text"},[_c('TextLead',{attrs:{"text":"ＪＲ九州グループの一員である当社は、「安全とサービスを基盤として九州、日本、そしてアジアの元気をつくる企業グループ」を“あるべき姿”として、「また会いたくなる場所へ」をポリシーに、東京、福岡、長崎、大分、熊本、宮崎、鹿児島及び那覇に宿泊主体型ホテルを展開しています。<br>このほか、日本有数の温泉地・別府、嬉野で温泉旅館を運営しています。"}})],1)])]),_c('section',{staticClass:"company"},[_c('div',{staticClass:"company__inner"},[_c('TitleLarge',{attrs:{"text":"会社概要"}}),_c('div',{staticClass:"company__content"},[_c('TableBorder',{attrs:{"table":[
            {
              th: '会社名',
              td: 'ＪＲ九州ホテルズアンドリゾーツ株式会社',
            },
            {
              th: '本社所在地',
              td: '〒812-0013 福岡市博多区博多駅東1丁目17番1号コネクトスクエア博多5階',
            },
            {
              th: '会社設立',
              td: '2023年1月23日',
            },
            {
              th: '資本金',
              td: '1億円',
            },
            {
              th: '株&emsp;&emsp;主',
              td: '九州旅客鉄道株式会社100％',
            }
          ]}})],1)],1)]),_c('section',{staticClass:"hotel"},[_c('div',{staticClass:"hotel__inner"},[_c('TitleLarge',{attrs:{"text":"ホテル一覧"}}),_c('div',{staticClass:"hotel__content"},[_c('ListHotel',{attrs:{"column":[
            {
              head: '',
              image: 'profile/img-hotel-12.jpg',
              title: 'THE BLOSSOM HIBIYA',
              address: '〒105-0004<br>東京都港区新橋1丁目1番13号<br>客室数 255室',
            },
            {
              head: '',
              image: 'profile/img-hotel-15.jpg',
              title: 'THE BLOSSOM KYOTO',
              address: '〒600-8104<br>京都府京都市下京区五条通東洞院 東入万寿寺町140番地２<br>客室数 180室',
            },
            {
              head: '',
              image: 'profile/img-hotel-13.jpg',
              title: 'THE BLOSSOM HAKATA Premier',
              address: '〒812-0011<br>福岡県福岡市博多区博多駅前2丁目8番12号<br>客室数 238室',
            },
            {
              head: '',
              image: 'profile/img-hotel-14.jpg',
              title: 'THE BLOSSOM KUMAMOTO',
              address: '〒860-0047<br>熊本市西区春日3丁目15番26号<br>客室数 203室',
            } ]}}),_c('ListHotel',{attrs:{"column":[
            {
              head: '',
              image: 'profile/img-hotel-01.jpg',
              title: 'ＪＲ九州ホテル<br>ブラッサム新宿',
              address: '〒151-0053<br>東京都渋谷区代々木2丁目6番2号<br>客室数 239室',
            },
            {
              head: '',
              image: 'profile/img-hotel-02.jpg',
              title: 'ＪＲ九州ホテル<br>ブラッサム博多中央',
              address: '〒812-0011<br>福岡県福岡市博多区博多駅前2丁目2番11号<br>客室数 247室',
            },
            {
              head: '',
              image: 'profile/img-hotel-03.jpg',
              title: 'ＪＲ九州ホテル<br>ブラッサム福岡',
              address: '〒812-0013<br>福岡県福岡市博多区博多駅東2丁目2番4号<br>客室数 90室',
            },
            {
              head: '',
              image: 'profile/img-hotel-04.jpg',
              title: 'ＪＲ九州ホテル<br>ブラッサム大分',
              address: '〒870-0831<br>大分県大分市要町1番14号<br>客室数 190室',
            },
            {
              head: '',
              image: 'profile/img-hotel-05.jpg',
              title: 'ＪＲ九州ホテル<br>ブラッサム那覇',
              address: '〒900-0013<br>沖縄県那覇市牧志2丁目16番1号<br>客室数 218室',
            } ]}}),_c('ListHotel',{attrs:{"column":[
            {
              head: '',
              image: 'profile/img-hotel-07.jpg',
              title: 'ＪＲ九州ホテル<br>長崎',
              address: '〒850-0058<br>長崎県長崎市尾上町1番1号<br>客室数 144室',
            },
            {
              head: '',
              image: 'profile/img-hotel-08.jpg',
              title: 'ＪＲ九州ホテル<br>宮崎',
              address: '〒880-0811<br>宮崎県宮崎市錦町1番10号<br>客室数 141室',
            },
            {
              head: '',
              image: 'profile/img-hotel-09.jpg',
              title: 'ＪＲ九州ホテル<br>鹿児島',
              address: '〒890-0045<br>鹿児島県鹿児島市武1丁目1番2号<br>客室数 247室<br>北館 134室／南館 113室',
            } ]}}),_c('ListHotel',{staticClass:"is-mariot",attrs:{"column":[
            {
              head: '',
              image: 'profile/img-hotel-17.jpg',
              title: '長崎マリオット<br>ホテル',
              address: '〒850-0058<br>長崎県長崎市尾上町1番1号<br>客室数 207室',
            },
            {
              head: '',
              image: 'profile/img-hotel-18.jpg',
              title: 'ホテルオークラＪＲ<br>ハウステンボス',
              address: '〒859-3296<br>長崎県佐世保市ハウステンボス町10番<br>客室数 320室',
            },
            {
              head: '',
              image: 'profile/img-hotel-19.jpg',
              title: 'ＪＲ九州ステーションホテル小倉',
              address: '〒802-0001<br>福岡県北九州市小倉北区浅野1丁目1番1号<br>客室数 294室',
            } ]}}),_c('ListHotel',{staticClass:"is-inn",attrs:{"column":[
            {
              head: '旅館',
              image: 'profile/img-hotel-16.jpg',
              title: '嬉野八十八',
              address: '〒843-0301<br>佐賀県嬉野市嬉野町大字下<br>宿丙2400-30<br>客室数 36室',
            },
            {
              head: '',
              image: 'profile/img-hotel-11.jpg',
              title: '別府温泉-竹と椿のお宿- 花べっぷ',
              address: '〒874-0908<br>大分県別府市上田の湯町16番50号<br>客室数 30室',
            } ]}})],1)],1)]),_c('BoxEntry')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }